import React from 'react';
import PropTypes from 'prop-types';

import { PagingButton } from 'display/common/components/buttons.jsx';

/*
*  This is the component that displays the arrows on the carousel.  It allows
*  paging sequentially through the slides.
*  @author Clay Kirk
*/
class CarouselPagingToolbar extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { showPrev, showNext, prevLabel, nextLabel } = this.props;
    return (
      <div className="xActionContainer xActionsPagination">
        <div className="xPaginationContainer xPaginateShowMore">
          <PagingButton key="1" onClick={showPrev} className="xPagingButton xActionPaginate xActionPrevious">
            {prevLabel}
          </PagingButton>
          <PagingButton key="2" onClick={showNext} className="xPagingButton xActionPaginate xActionNext">
            {nextLabel}
          </PagingButton>
        </div>
      </div>
    );
  }
}
CarouselPagingToolbar.propTypes = {
  nextLabel: PropTypes.string,
  prevLabel: PropTypes.string,
  showNext:  PropTypes.func.isRequired,
  showPrev:  PropTypes.func.isRequired
};

CarouselPagingToolbar.defaultProps = {
  nextLabel: 'Next',
  prevLabel: 'Previous'
};

export default CarouselPagingToolbar;
